// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"b1be92a8d5d8ab7e598f","303":"66f1d56b8e1c991c89ac","495":"70eca080a90cfa467ab9"}[chunkId] + ".js";
};